module.exports = __webpack_public_path__ + "img/arr-sm-up-icon.b4601762.svg";